import axiosInstance from "./global-instance";
import { b2cFinanceApiUrl } from "../constants/url-constants";
import createScopedApi from "./createScopedApi";

const BASE_API_URL = `${b2cFinanceApiUrl()}`;

export default createScopedApi(BASE_API_URL, axiosInstance);
